export const claims = {
  ViewDashboard: 'ViewDashboard',
  AddDashboard: 'AddDashboard',
  EditDashboard: 'EditDashboard',
  DeleteDashboard: 'DeleteDashboard',
  DashboardDefaultView: 'DashboardDefaultView ',
  DashboardAdvancedView: 'DashboardAdvancedView',

  ViewCalendar: 'ViewCalendar',

  ViewReservation: 'ViewReservation',
  ViewBasicReservation: 'ViewBasicReservation',
  AddReservation: 'AddReservation',
  EditReservation: 'EditReservation',
  DeleteReservation: 'DeleteReservation',

  ViewOccupancies: 'ViewOccupancies',

  ViewGuest: 'ViewGuest',
  AddGuest: 'AddGuest',
  EditGuest: 'EditGuest',
  DeleteGuest: 'DeleteGuest',

  ViewMessaging: 'ViewMessaging',
  EditMessaging: 'EditMessaging',
  ViewAIMessaging: 'ViewAIMessaging',

  ViewPartners: 'ViewPartners',
  AddPartners: 'AddPartners',
  EditPartners: 'EditPartners',
  DeletePartners: 'DeletePartners',

  ViewRenters: 'ViewRenters',

  ViewRepresentative: 'ViewRepresentative',
  ViewAssignee: 'ViewAssignee',
  ViewOffice: 'ViewOffice',

  ViewObject: 'ViewObject',
  AddObject: 'AddObject',
  EditObject: 'EditObject',
  DeleteObject: 'DeleteObject',

  ViewCM: 'ViewCM',
  ViewChannelManagerBasic: 'ViewChannelManagerBasic',

  ViewPartnerBenefits: 'ViewPartnerBenefits',
  PartnerBenefits: 'Partner benefits',

  ViewAnalytics: 'ViewAnalytics',

  ViewActivity: 'ViewActivity',

  ViewNotifications: 'ViewNotifications',

  ViewAccountSettings: 'ViewAccountSettings',

  ViewCooperationWithRenters: 'ViewCooperationWithRenters',

  ViewUserManagement: 'ViewUserManagement',

  ViewSubscription: 'ViewSubscription',
  ViewPriceManaging: 'ViewPriceManaging',

  ViewSettings: 'ViewSettings',

  ViewTasks: 'ViewTasks',

  ViewAccomodationSearch: 'ViewAccomodationSearch',

  ViewInvoices: 'ViewInvoices',

  ViewAdvanceFiltering: 'ViewAdvanceFiltering',
  ViewAdriagateAutomatic: 'ViewAdriagateAutomatic',
};
